/**
 * Permisos generales: qué partes de la plataforma usa una persona. Lo que puede hacer con un
 * expediente concreto no sale de aquí sino de su relación con él (CaseAbilities): la tarea que
 * tiene asignada, ser el responsable o estar en la cadena de mando del organigrama.
 */
export const Permission = {
    /** Ver los expedientes de sus áreas (y subáreas) y aquellos en que participa. */
    CASE_READ: 'case.read',
    /** Ver los expedientes de toda la entidad. */
    CASE_READ_ALL: 'case.read.all',
    /** Radicar solicitudes desde el backoffice. */
    CASE_CREATE: 'case.create',
    REPORTS_READ: 'reports.read',
    /** «Correos no enviados» en el menú (y su aviso arriba de cada pantalla): los correos al ciudadano que no salieron, de los casos que ve. */
    EMAILS_FAILED: 'emails.failed',
    AUDIT_READ: 'audit.read',
    /** Configuración › Plantillas: crear y editar plantillas, también las de cada área y tipo de caso. Lo trae el Administrador; sirve para un rol que solo las administre. */
    TEMPLATES_MANAGE: 'templates.manage',
    /** Toda la configuración, incluido el diseño y la publicación de workflows. */
    ADMIN_MANAGE: 'admin.manage',
    /** Configuración avanzada: piezas que solo ve y edita quien lo tiene. Adicional a admin.manage, nunca lo reemplaza; ningún rol lo trae por defecto salvo el Super. */
    ADMIN_ADVANCED: 'admin.advanced',
};
export const ALL_PERMISSIONS = Object.values(Permission);
/**
 * Roles de sistema (migraciones 0007 y 0021). Super y Administrador están bloqueados: sus permisos no se editan.
 * Super tiene todos; Administrador, todos menos la configuración avanzada. El orden de este objeto es el de los listados.
 */
export const SystemRole = { CONSULTA: 'CONSULTA', FUNCIONARIO: 'FUNCIONARIO', ADMIN: 'ADMIN', SUPER: 'SUPER' };
export const ADMIN_PERMISSIONS = ALL_PERMISSIONS.filter((p) => p !== Permission.ADMIN_ADVANCED);
/** Permisos fijos de los roles bloqueados; `principal.service` los usa en vez de los guardados, así incluyen los que se agreguen después. */
export const LOCKED_ROLE_PERMISSIONS = { [SystemRole.SUPER]: ALL_PERMISSIONS, [SystemRole.ADMIN]: ADMIN_PERMISSIONS };
export const isLockedRole = (code) => code in LOCKED_ROLE_PERMISSIONS;
export const FUNCIONARIO_PERMISSIONS = [Permission.CASE_READ, Permission.CASE_CREATE];
export const CONSULTA_PERMISSIONS = [Permission.CASE_READ_ALL, Permission.REPORTS_READ, Permission.AUDIT_READ];
//# sourceMappingURL=permissions.js.map